import styled from 'styled-components';
import * as S from '../Span/Span.styles';
import { getAlign } from '../utils';

export const P = styled(S.Span)`
  ${({ align }) => getAlign(align)}
`;
